module.exports = __webpack_public_path__ + "img/CCC-HTF-12-1.c7182fa2.jpg";